import React from 'react';
import AttributionReport from './AttributionReport';
import EntityCardSkeleton from '../../components/EntityCardSkeleton';

const AttributionTab = ({ campaign, chartData, chartsLoading }) => {
  if (chartsLoading) return <EntityCardSkeleton />;

  return <AttributionReport campaign={campaign} chartData={chartData} />;
};

export default AttributionTab;
